import {Fragment, h} from "preact";

const SelectBankCardForm = ({bankCards, bankCardId, onChangeBankCard, saveBankCard, changeSaveBankCard}) => {
	const cardList = Array.isArray(bankCards) ? bankCards.map(item => ({
		id: item.id,
		pan: item.pan,
		icon: item.icon,
	})):{};

	cardList.push({
		id: null,
		pan: 'Новая карта',
		icon: null,
	})

	const selectedCard = cardList.find(item => (bankCardId === item.id) || (!bankCardId && !item.id))

	return (
		<Fragment>
			<div className="form-block__line">
				<div className="form-field">
					<div className="form-field__inner">
						{/*<div className="form-field__title-row">
							<legend className="form-field__title">Банковская карта</legend>
						</div>*/}
						<div className="form-field__input-row">
							<div className="select form-field__select js__tabselect">
								<button className="select__button select__button--payForm" data-dsdd="">
									{!!selectedCard && (
										<span>
											{!!selectedCard.icon && (
												<img src={selectedCard.icon} alt=""/>
											)}
											{selectedCard.pan}
										</span>
									)}
								</button>
								<ul className="select__list dsdd-menu">
									{cardList.map(card => {
										const checked = selectedCard === card;
										return (
											<li className="select__item" key={card.id}>
												<input
													className="select__input"
													name="card" type="radio"
													checked={checked}
													onChange={onChangeBankCard(card.id)}
												/>
												<label className="select__label" onClick={onChangeBankCard(card.id)}>
													{!!card.icon && (
														<img src={card.icon} alt=""/>
													)}
													<span>{card.pan}</span>
												</label>
											</li>
										)
									})}
								</ul>
							</div>
						</div>
					</div>
				</div>
			</div>
			{!bankCardId && (
				<div className="form-block__line">
					<label className="checkbox checkbox--payForm">
						<input className="checkbox__input" type="checkbox" checked={!!saveBankCard} onChange={e => changeSaveBankCard(!saveBankCard)}/>
						<span className="checkbox__label"></span>
						<span className="checkbox__text">Запомнить карту после оплаты</span>
					</label>
				</div>
			)}
		</Fragment>
	);
};

export default SelectBankCardForm;